const DATE_FORMAT_NO_TIME = "MM/DD/YYYY";
const DATE_FORMAT_MONTH = "MMMYY";
const DATE_FORMAT = `${DATE_FORMAT_NO_TIME} HH:mm`;
const DATE_FORMAT_WITH_SECONDS = `${DATE_FORMAT}:ss`;
const DATE_FORMAT_WITH_TIMEZONE = `${DATE_FORMAT} z`;

const MYSQL_DATE_FORMAT = "YYYY-MM-DD";
const MYSQL_DATE_FORMAT_WITH_TIME = `${MYSQL_DATE_FORMAT} HH:mm:ss`;

// date pickers seems to need their bound values stored in this format
const DATE_PICKER_FORMAT = MYSQL_DATE_FORMAT;

/**
 * https://momentjs.com/timezone/docs/ gets it timezones from https://www.iana.org/time-zones
 * 
 * This is the one that seems to represent Utah.
 */
const TIMEZONE = "America/Denver";
var GENDERS = [{
        "name": "Male",
        "value": "M"
    },
    {
        "name": "Female",
        "value": "F"
    }
];

// relates to data in DailyHusbandryTaskTypes table - does not include all data (we only reference some of them)
const DAILY_HUSBANDRY_TYPES = {
    UPDATE_WEIGHT: 7,
    UPDATE_LOCATION: 8,
    SPECIMEN_DECEASED: 9,
    SPECIMEN_EUTHANISED: 17
};

module.exports = {
    DATE_FORMAT,
    DATE_FORMAT_NO_TIME,
    DATE_FORMAT_WITH_TIMEZONE,
    DATE_FORMAT_WITH_SECONDS,
    TIMEZONE,
    MYSQL_DATE_FORMAT,
    MYSQL_DATE_FORMAT_WITH_TIME,
    GENDERS,
    DATE_PICKER_FORMAT,
    DAILY_HUSBANDRY_TYPES,
    DATE_FORMAT_MONTH
}